import { AxiosResponse } from 'axios';
import { useFormik } from 'formik';
import { useEffect, useRef, useState } from 'react';
import { ModelOfProductBrand } from '../../database';
import api from '../../services/api';
import * as Yup from 'yup';
import { useAuth } from 'src/contexts/auth';

export const useListProductBrandsController = () => {
	const [ProductBrandData, setProductBrandsData] = useState<ModelOfProductBrand[]>([]);
	const [selectedProductBrand, setSelectedProductBrand] = useState<ModelOfProductBrand>();
	const [loading, setLoading] = useState(true);
	const [editDialog, setEditDialog] = useState(false);
	const [deleteDialog, setDeleteDialog] = useState(false);

	const toast: any = useRef();
	const { userAgencyId } = useAuth();

	const validationSchema = Yup.object().shape({
		DESCRICAO: Yup.string().required('* Campo obrigatório'),
	});

	const getProductBrands = () => {
		api.get(`products-brands/${userAgencyId}`)
			.then(response => {
				const data = response.data;
				setProductBrandsData(data);
				setLoading(false);
			})
			.catch((response: AxiosResponse) => {
				console.log('erro: ', response.status);
				setLoading(false);
			});
	};

	const removeProductBrand = (ProductBrand: ModelOfProductBrand) => {
		setLoading(true);
		api.delete(`products-brands/${ProductBrand.ID}`)
			.then(() => {
				getProductBrands();
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Remoção realizada',
					detail: 'A marca foi removida com sucesso!',
					life: 5000,
				});
			})
			.catch(err => {
				getProductBrands();
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Remoção não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	const editProductBrand = (ProductBrand: ModelOfProductBrand) => {
		setLoading(true);

		const editedProductBrand: ModelOfProductBrand = {
			...ProductBrand,
		};

		api.put(`products-brands/${selectedProductBrand?.ID}`, editedProductBrand)
			.then(() => {
				getProductBrands();
				setEditDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Edição realizada',
					detail: 'A marca foi editada com sucesso!',
					life: 5000,
				});
			})
			.catch(err => {
				getProductBrands();
				setEditDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Edição não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	useEffect(() => {
		getProductBrands();
	}, []);

	const openDeleteDialog = (ProductBrand: ModelOfProductBrand) => {
		setDeleteDialog(true);
		setSelectedProductBrand(ProductBrand);
	};

	const closeDeleteDialog = () => {
		setDeleteDialog(false);
	};

	const openEditDialog = (ProductBrand: ModelOfProductBrand) => {
		setEditDialog(true);
		setSelectedProductBrand(ProductBrand);
	};

	const closeEditDialog = () => {
		setEditDialog(false);
	};

	const formik = useFormik<ModelOfProductBrand>({
		initialValues: {
			DESCRICAO: '',
		},
		onSubmit: values => editProductBrand(values),
		validationSchema,
	});

	return {
		getProductBrandListController: {
			formik,
			ProductBrandData,
			selectedProductBrand,
			loading,
			deleteDialog,
			editDialog,
			toast,
		},
		handleProductBrandListController: {
			removeProductBrand,
			editProductBrand,
			openDeleteDialog,
			closeDeleteDialog,
			openEditDialog,
			closeEditDialog,
			getProductBrands,
		},
	};
};
